import { render, staticRenderFns } from "./ConfigNav.vue?vue&type=template&id=c75b5986&scoped=true"
import script from "./ConfigNav.vue?vue&type=script&lang=js"
export * from "./ConfigNav.vue?vue&type=script&lang=js"
import style0 from "./ConfigNav.vue?vue&type=style&index=0&id=c75b5986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75b5986",
  null
  
)

export default component.exports